import { render, staticRenderFns } from "./editCorpPartnerList.vue?vue&type=template&id=f2d03ad8&"
import script from "./editCorpPartnerList.vue?vue&type=script&lang=js&"
export * from "./editCorpPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports